<template>
    <div class="totem-last-watched-tag">
        <span v-html="$t('UncompletedCourses.last_watched')"></span>
        <span>{{ getFormattedTimeSinceLastWatched(course.lastActivityDateAndTime) }}</span>
    </div>
</template>

<script>
    export default {
        name: 'totem-last-watched-tag',
        props: {
            course: Object
        },
        methods: {
            getFormattedTimeSinceLastWatched (dateString) {
                const currentDate = new Date()
                currentDate.setHours(0, 0, 0, 0)

                const lastWatchedDate = new Date(dateString)
                lastWatchedDate.setHours(0, 0, 0, 0)

                const timeDiff = currentDate - lastWatchedDate

                const seconds = Math.floor(timeDiff / 1000)
                const minutes = Math.floor(seconds / 60)
                const hours = Math.floor(minutes / 60)
                const days = Math.floor(hours / 24)
                const weeks = Math.floor(days / 7)
                const months = Math.floor(days / (365 / 12))
                const years = Math.floor(days / 365)

                if (days === 0) {
                    return `${this.$t('LastWatched.today')}`
                } else if (days === 1) {
                    return `${this.$t('LastWatched.yesterday')}`
                } else if (days < 7) {
                    return `${days} ${this.$t('LastWatched.days_ago')}`
                } else if (weeks === 1) {
                    return `${weeks} ${this.$t('LastWatched.week_ago')}`
                } else if (weeks <= 4 && months === 0) {
                    return `${weeks} ${this.$t('LastWatched.weeks_ago')}`
                } else if (months === 1) {
                    return `${months} ${this.$t('LastWatched.month_ago')}`
                } else if (months < 12) {
                    return `${months} ${this.$t('LastWatched.months_ago')}`
                } else if (years === 1) {
                    return `${years} ${this.$t('LastWatched.year_ago')}`
                } else {
                    return `${years} ${this.$t('LastWatched.years_ago')}`
                }
            }
        }
    }
</script>

<style lang="scss">
    .totem-last-watched-tag {
        display: inline-flex;
        align-items: center;
        padding: 0 12px;
        margin: 0 6px 6px 0;
        border-radius: 3px;
        height: 22px;
        background: $bright_gray;
        position: relative;
        gap: 5px;
        font-size: 1.4rem;
    }
</style>
